import { render } from "./Family-member--personal-details-contact-information.vue?vue&type=template&id=5d429b2c"
import script from "./Family-member--personal-details-contact-information.vue?vue&type=script&lang=ts"
export * from "./Family-member--personal-details-contact-information.vue?vue&type=script&lang=ts"
script.render = render

export default script